const customerDetail = () => import('@/views/main/customer/detail/detail.vue')
export default {
  path: '/main/customer/detail',
  name: 'customerDetail',
  component: customerDetail,
  children: []
}
